export default {
  meta: {
    title: '待指派拓店任务',
  },
};
